
export default function About() {
  return (
    <section id="about" className="py-20 bg-gray-100">
      <div className="container mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-black mb-6">
              Tradition trifft Innovation
            </h2>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              In der ehemaligen Lederwarenfabrik in Remagen-Kripp haben wir unser Zuhause gefunden. 
              Die historischen Backsteinmauern erzählen Geschichten von Handwerkskunst und Qualität - 
              Werte, die wir in die moderne Fulfillment-Welt übertragen.
            </p>
            <p className="text-lg text-gray-700 mb-8 leading-relaxed">
              Jedes Paket, das unser Haus verlässt, trägt ein Stück dieser Tradition in sich. 
              Wir glauben daran, dass in einer digitalisierten Welt die menschliche Note 
              den Unterschied macht.
            </p>
            
            <div className="grid grid-cols-2 gap-6">
              <div className="text-center">
                <div className="text-3xl font-bold text-black mb-2">500+</div>
                <div className="text-gray-600">Pakete täglich</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-black mb-2">99.8%</div>
                <div className="text-gray-600">Zufriedenheit</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-black mb-2">24h</div>
                <div className="text-gray-600">Bearbeitungszeit</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-black mb-2">100%</div>
                <div className="text-gray-600">Handgepackt</div>
              </div>
            </div>
          </div>

          <div className="relative">
            <img 
              src="https://readdy.ai/api/search-image?query=Historic%20German%20brick%20factory%20interior%20with%20high%20ceilings%2C%20black%20and%20white%20photography%2C%20monochrome%20industrial%20lighting%2C%20wooden%20work%20tables%20with%20carefully%20packed%20packages%2C%20traditional%20craftsmanship%20atmosphere%2C%20workers%20in%20aprons%20handling%20packages%20with%20care%2C%20vintage%20industrial%20charm%20meets%20modern%20efficiency%2C%20dramatic%20black%20and%20white%20photography%2C%20high%20contrast&width=600&height=800&seq=about-img-bw&orientation=portrait"
              alt="Unsere Manufaktur in Remagen-Kripp"
              className="rounded-xl shadow-lg object-cover w-full h-96 lg:h-full"
            />
            <div className="absolute -bottom-6 -left-6 bg-white p-6 rounded-lg shadow-lg border border-gray-200">
              <div className="flex items-center space-x-3">
                <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center">
                  <i className="ri-heart-fill text-xl" style={{color: '#B80E10'}}></i>
                </div>
                <div>
                  <div className="font-bold text-black">Mit Liebe gepackt</div>
                  <div className="text-sm text-gray-600">seit 2020</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
